import React from 'react'
import { NavLink } from 'react-router-dom'
import { DropList, NavBar } from '../widgetStyles/Styles'
import { Checkbox } from './Checkbox'
import { ThemeController } from '../utils/Theme'

const switchTheme = (e) => {
    ThemeController(e.target.checked)
}

export const Header = () => (
    <header className="bl-bg pd-lr pd-tb ps">
        <div className="df">
            <NavLink to="/crowd-detection/" className={"df except_under"} style={{marginLeft: "40px"}}>
                <img src="./img/logo.png" className="logo" alt="logo" />
                <span className="fs-b logo_font">Vegas ML</span>
            </NavLink>
            <NavBar className="df mla">
                <DropList>
                    <NavLink to="/crowd-detection/products" className="fs-n">Products</NavLink>
                    <div>
                        <NavLink to="/crowd-detection/solutions" className="fs-n">Solutions</NavLink>
                        <NavLink to="/crowd-detection/support" className="fs-n">Support</NavLink>
                        <NavLink to="/crowd-detection/partners" className="fs-n">Partners</NavLink>
                    </div>
                </DropList>
                <DropList>
                    <NavLink to="/crowd-detection/solutions" className="fs-n">Solutions</NavLink>
                    <div>
                        <NavLink to="/crowd-detection/products" className="fs-n">Products</NavLink>
                        <NavLink to="/crowd-detection/solutions" className="fs-n">Solutions</NavLink>
                        <NavLink to="/crowd-detection/support" className="fs-n">Support</NavLink>
                        <NavLink to="/crowd-detection/partners" className="fs-n">Partners</NavLink>
                    </div>
                </DropList>
                <DropList>
                    <NavLink to="/crowd-detection/support" className="fs-n">Support</NavLink>
                    <div>
                        <NavLink to="/crowd-detection/solutions" className="fs-n">Returns</NavLink>
                        <NavLink to="/crowd-detection/about" className="fs-n">Warranty</NavLink>
                        <NavLink to="/crowd-detection/docs" className="fs-n">Product Registration</NavLink>
                        <NavLink to="/crowd-detection/docs" className="fs-n">Help</NavLink>
                    </div>
                </DropList>
                <DropList>
                    <NavLink to="/crowd-detection/partners" className="fs-n">Partners</NavLink>
                    <div>
                        <a href="https://www.bsuir.by/" className="fs-n">BSUIR</a>
                        <a href="https://iba.by/" className="fs-n">IBA Group</a>
                    </div>
                </DropList>
                <NavLink to="/crowd-detection/signup" className={" except_under input_button"}>Get for free</NavLink>
                <div className={"df jcc"}>
                    <Checkbox onChecked={e => switchTheme(e)} />
                </div>
                <NavLink to="/crowd-detection/signup" className={"df jcc except_under"}>
                    <img src="./img/account.svg" className="icon" alt="log in" />
                </NavLink>
            </NavBar>
        </div>
    </header>
)


